<template>
    <div>
        <Toolbar>
            <!-- LEFT -->
            <BackButton :to="__('navigation.dashboard')" :href="$route('connectors.index')"/>

        </Toolbar>
        <Card>
            <template v-slot:title>{{ __('general.connector') }}</template>
            <template v-slot:description>
                {{ __('actions.manage_thing', {thing: __('general.connector')}) }}
            </template>
            <div>
                <EditConnector :init-stores="stores" :settings="settings"></EditConnector>
            </div>
        </Card>
    </div>
</template>

<script>
import BackButton from "@components/BackButton.vue";
import Card from "@components/Cards/Card";
import Toolbar from "@components/ToolbarLink";
import EditConnector from "@components/Connectors/EditConnector";
export default {
    components: {Toolbar, Card, BackButton, EditConnector},
    props: {
        stores: {
            type: Array,
            default: () => [],
        },
        settings: {
            type: Object,
            default: () => {},
        }
    },

    computed: {

    },
}
</script>
